export default __webpack_public_path__ + "static/media/language-of-trust.901073e8.png";